// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter__qQEEM","negative":"negative__fd-DG"};